/**
 * Bilder fra kommunalt galleri lagres i `Seksjonselementer.Beskrivelse` som
 * `__kommunalt_bilde:<url>\n<beskrivelse>`. Formatet deles av admin og
 * innbyggerappen, så det kodes og leses bare her.
 */
export const KOMMUNALT_BILDE_PREFIX = '__kommunalt_bilde:';

export interface KommunaltBilde {
    /** Permanent URL til bildet i kommunalt galleri. */
    bildeUrl: string;
    /** Beskrivelsen etter bilde-URL-en (urørt — ikke trimmet). */
    beskrivelse: string;
}

/** Leser et lagret kommunalt bilde, eller `null` hvis beskrivelsen ikke er ett. */
export function lesKommunaltBilde(beskrivelse: string | null | undefined): KommunaltBilde | null {
    if (!beskrivelse?.startsWith(KOMMUNALT_BILDE_PREFIX)) return null;
    const rest = beskrivelse.slice(KOMMUNALT_BILDE_PREFIX.length);
    const nl = rest.indexOf('\n');
    return nl >= 0
        ? { bildeUrl: rest.slice(0, nl), beskrivelse: rest.slice(nl + 1) }
        : { bildeUrl: rest, beskrivelse: '' };
}

/** Lager `Beskrivelse`-verdien for et kommunalt bilde. */
export function lagKommunaltBildeBeskrivelse(bildeUrl: string, beskrivelse: string | null | undefined): string {
    return `${KOMMUNALT_BILDE_PREFIX}${bildeUrl}\n${beskrivelse ?? ''}`.trimEnd();
}
